import "./Form.css"

function Form({className, children, onSubmit}) {
    return (
        <form onSubmit={onSubmit} className={"form " + (className ? className : "")}>
            {children}
        </form>
    )
}
Form.Title = ({children, className = ''}) => <div className={"first-row " + (className ? className : "")}><span className="title">{children}</span></div>
Form.Buttons = ({children, className = ''}) => <div className={"last-row " + (className ? className : "")}>{children}</div>
Form.Body = ({children, className = ''}) => <div className={"center " + (className ? className : "")}>{children}</div>

export default Form;